import { createContext } from 'react';

import { PersistenceState } from './types';

export const TablePersistence = createContext<PersistenceState>({
  accept: () => {},
  retrieve: ({ state }) => state,
});
